import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import './StringDialogEditor.scss';

const StringDialogEditor = (props) => {
  const { value, onValueChange, editor, className, ...rest } = props;
  const handleChange = (event) => {
    let s = event.target.value;
    s = editor.displayToData ? editor.displayToData(s, rest) : s;
    onValueChange(s || undefined);
  };
  const displayValue = editor.dataToDisplay ? editor.dataToDisplay(value, rest) : value;
  return (
    <FormControl
      className={classnames('grbrsm-string-dialog-editor', className)}
      style={props.style}
    >
      <InputLabel htmlFor={`input${editor.name}`}>{editor.title}</InputLabel>
      <Input
        id={`input${editor.name}`}
        aria-describedby={`input${editor.name} helper text`}
        onChange={handleChange}
        value={displayValue || ''}
      />
    </FormControl>
  );
};

StringDialogEditor.propTypes = {
  value: PropTypes.string,
  editor: PropTypes.shape({
    displayToData: PropTypes.func,
    dataToDisplay: PropTypes.func,
    title: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

StringDialogEditor.defaultProps = {
  value: undefined,
  className: undefined,
  style: undefined,
};

export default StringDialogEditor;
